/* ============================================================
   XALANI – GDPR Cookie Consent  |  cookie-consent.js
   Vanilla JS, IIFE, kein Framework
   ============================================================ */
(function () {
  'use strict';

  /* ---- Konstanten ---- */
  var STORAGE_KEY    = 'xalani_gdpr_consent';
  var EXPIRY_DAYS    = 365;
  var SHOPIFY_RETRY  = 10;   // max. Versuche für Shopify API
  var SHOPIFY_DELAY  = 200;  // ms zwischen Versuchen

  /* ---- localStorage Helpers ---- */

  function getStoredConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.timestamp) return null;
      var ageMs  = Date.now() - data.timestamp;
      var maxMs  = EXPIRY_DAYS * 24 * 60 * 60 * 1000;
      if (ageMs > maxMs) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function saveConsent(analytics, marketing) {
    try {
      var data = {
        necessary : true,
        analytics : !!analytics,
        marketing : !!marketing,
        timestamp : Date.now(),
        version   : '1'
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  /* ---- EU / GDPR-Region Detection ---- */

  function isGDPRRegion() {
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.shouldShowGDPR === 'function'
      ) {
        return window.Shopify.customerPrivacy.shouldShowGDPR();
      }
    } catch (e) {}
    // Sicherer Fallback: immer anzeigen (DSGVO-konform)
    return true;
  }

  /* ---- Google Consent Mode v2 ---- */

  function updateGCM(analytics, marketing) {
    try {
      if (typeof gtag !== 'function') return;
      gtag('consent', 'update', {
        analytics_storage  : analytics ? 'granted' : 'denied',
        ad_storage         : marketing  ? 'granted' : 'denied',
        ad_user_data       : marketing  ? 'granted' : 'denied',
        ad_personalization : marketing  ? 'granted' : 'denied'
      });
    } catch (e) {}
  }

  /* ---- Shopify Customer Privacy API ---- */

  function doSetTrackingConsent(analytics, marketing, onSuccess) {
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics    : !!analytics,
        marketing    : !!marketing,
        preferences  : false,
        sale_of_data : false
      },
      function () {
        if (typeof onSuccess === 'function') onSuccess();
      }
    );
  }

  function applyShopifyConsent(analytics, marketing, onSuccess, attempt) {
    attempt = attempt || 0;
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
    ) {
      doSetTrackingConsent(analytics, marketing, onSuccess);
    } else if (attempt < SHOPIFY_RETRY) {
      setTimeout(function () {
        applyShopifyConsent(analytics, marketing, onSuccess, attempt + 1);
      }, SHOPIFY_DELAY);
    }
  }

  // Offizielles Shopify-Event – auch abfangen wenn Event bereits vor Script-Ausführung feuerte
  document.addEventListener('customerPrivacyApiLoaded', function () {
    var stored = getStoredConsent();
    if (stored) {
      doSetTrackingConsent(stored.analytics, stored.marketing);
    }
  });
  // Sofort prüfen falls Event bereits gefeuert hat (defer-Script lädt nach dem Event)
  if (
    window.Shopify &&
    window.Shopify.customerPrivacy &&
    typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
  ) {
    var _earlyStored = getStoredConsent();
    if (_earlyStored) {
      doSetTrackingConsent(_earlyStored.analytics, _earlyStored.marketing);
    }
  }

  /* ---- GA4 Event Tracking ---- */

  function trackEvent(eventName, params) {
    try {
      if (window.Shopify && window.Shopify.designMode) return; // kein Tracking im Editor
      if (typeof gtag === 'function') {
        gtag('event', eventName, params || {});
      }
    } catch (e) {}
  }

  /* ---- Consent anwenden (speichern + GCM + Shopify) ---- */

  function applyConsent(analytics, marketing, onSuccess) {
    saveConsent(analytics, marketing);
    updateGCM(analytics, marketing);
    applyShopifyConsent(analytics, marketing, onSuccess);
  }

  /* ---- DOM Helpers ---- */

  function el(id) {
    return document.getElementById(id);
  }

  function show(elem) {
    if (elem) elem.removeAttribute('hidden');
  }

  function hide(elem) {
    if (elem) elem.setAttribute('hidden', '');
  }

  function showBanner() {
    show(el('xalani-cookie-banner'));
  }
  function hideBanner() { hide(el('xalani-cookie-banner')); }

  function showPanel() {
    var panel = el('xalani-cookie-panel');
    if (!panel) return;
    // Aktuelle gespeicherte Werte in Toggles vorbelegen
    var stored = getStoredConsent();
    var analyticsToggle = el('xalani-analytics-toggle');
    var marketingToggle = el('xalani-marketing-toggle');
    if (analyticsToggle) analyticsToggle.checked = stored ? !!stored.analytics : false;
    if (marketingToggle) marketingToggle.checked  = stored ? !!stored.marketing : false;
    show(panel);
    // Fokus auf ersten Button setzen (Accessibility)
    var firstBtn = panel.querySelector('button');
    if (firstBtn) firstBtn.focus();
  }

  function hidePanel() { hide(el('xalani-cookie-panel')); }

  /* ---- Init ---- */

  function init() {
    if (!el('xalani-cookie-banner')) return; // Snippet nicht geladen

    var stored = getStoredConsent();

    if (!isGDPRRegion()) {
      // Kein EU-Besucher: sofort volles Tracking aktivieren, kein Banner
      applyShopifyConsent(true, true);
      return;
    }

    if (stored) {
      // Returning visitor: gespeicherte Werte anwenden (GCM + Shopify)
      applyConsent(stored.analytics, stored.marketing);
      return;
    }

    // Neuer EU-Besucher ohne gespeicherten Consent:
    // Analytics sofort aktivieren (Legitimate Interest für Shopify-eigenes Session-Tracking),
    // Marketing bleibt deaktiviert bis zur expliziten Zustimmung.
    applyShopifyConsent(true, false);
    showBanner();
  }

  /* ---- Event-Listener ---- */

  function attachListeners() {
    // "Ok" – alles akzeptieren
    var acceptBtn = el('xalani-accept-btn');
    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        applyConsent(true, true, function () {
          trackEvent('cookie_all_accepted');
        });
        hideBanner();
      });
    }

    // "Einstellungen" – Panel öffnen
    var settingsBtn = el('xalani-settings-btn');
    if (settingsBtn) {
      settingsBtn.addEventListener('click', function () {
        hideBanner();
        showPanel();
      });
    }

    // "Einstellungen speichern" – Toggles auslesen
    var rejectBtn = el('xalani-reject-all-btn');
    if (rejectBtn) {
      rejectBtn.addEventListener('click', function () {
        var a = el('xalani-analytics-toggle') ? el('xalani-analytics-toggle').checked : false;
        var m = el('xalani-marketing-toggle') ? el('xalani-marketing-toggle').checked  : false;
        applyConsent(a, m, function () {
          if (!a && !m) {
            trackEvent('cookie_rejected');
          } else {
            trackEvent('cookie_custom_saved', { analytics: a, marketing: m });
          }
        });
        hidePanel();
      });
    }

    // "Alle akzeptieren" – alles akzeptieren
    var saveBtn = el('xalani-save-settings-btn');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        applyConsent(true, true, function () {
          trackEvent('cookie_all_accepted');
        });
        hidePanel();
      });
    }

    // Overlay-Klick schließt Panel
    var overlay = el('xalani-panel-overlay');
    if (overlay) {
      overlay.addEventListener('click', hidePanel);
    }

    // ESC-Taste schließt Panel
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && el('xalani-cookie-panel') && !el('xalani-cookie-panel').hasAttribute('hidden')) {
        hidePanel();
      }
    });

    // Footer-Link "Cookie-Einstellungen" [data-gdpr-settings] – Event Delegation
    document.addEventListener('click', function (e) {
      var target = e.target.closest('[data-gdpr-settings]');
      if (target) {
        e.preventDefault();
        showPanel();
      }
    });
  }

  /* ---- Shopify Theme Editor Support ---- */

  document.addEventListener('shopify:section:load', function () {
    attachListeners();
    init();
  });

  /* ---- Start ---- */

  function ready() {
    attachListeners();
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

})();
